
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Site Web par abonnement : la solution ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Cet article de blog vous explique le principe et les avantages d’un site Web sous la forme d’un forfait mensuel tout compris.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Site Web par abonnement : la solution ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article de blog vous explique le principe et les avantages d’un site Web sous la forme d’un forfait mensuel tout compris.",
        },
      ],
    };
  },
};
